






import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UDocsCategoryLink extends Vue {
  // Props
  @Prop({ default: "a" })
  public type!: string;

  // Computed

  public get link() {
    return {
      type: this.type,
      events: {
        click: () => {
          this.$emit("categorySelected");
        }
      }
    };
  }
}
